import React from 'react';
import Paper from 'material-ui/Paper';
import LinearProgress from 'material-ui/LinearProgress';
import { FormattedMessage } from 'react-intl'
import { checkMobile, checkPad } from '../../lib';
import AppBar from '../AppBar'

export default function Maintenance() {
  const styles = {
    paperContainer: {
      backgroundImage: 'linear-gradient(180deg, rgb(78,198,195), rgba(255,0,0,0))'
    },
    headingStyle : {
      textShadow: '2px 2px 5px #194B4B',
      fontWeight: 400,
      fontFamily: 'Marck Script',
      color: '#E7F0FF',
      fontSize: checkMobile() ? '30px' : '50px',
      color: "#000000"
    },
    subHeading: {
      textShadow: '2px 2px 5px #000000',
      fontWeight: 200,
      fontFamily: 'Marck Script',
      color: '#E7F0FF',
      fontSize: checkMobile() ? '20px' : '28px',
    },
    textStyle:{
      fontFamily: 'Marck Script',
      lineHeight: '1.6',
      backgroundImage: 'linear-gradient(to right, white, rgb(78,198,195), white)',
      padding: '10px',
      color:"black",
      fontSize: checkMobile() ? '11px' : '20px',
    },
    paperStyle: {
      height: screen.height < 500 ? screen.height- 130 :  screen.height- 210,
      marginTop:'20px', 
      width:"80%", 
      wordWrap: 'break-word', 
      textAlign:'center',  
      backgroundImage:'linear-gradient( rgba(255,0,0,0), rgb(78,198,195))'
    }
  };
  return (
    <div className="flex flex-column">
        <AppBar />
        <div className="flex justify-center flex-column items-center" style={styles.paperContainer}>
          <Paper elevation={3} spacing={0}
            direction="column"
            style={styles.paperStyle}>
            <LinearProgress />
            <div className='pa4 vertical-center'>
              <h1 className="mb3" style = {styles.headingStyle}>
                <FormattedMessage id="maintenance.heading" />
              </h1>
              <h2 style = {styles.subHeading}><FormattedMessage id="maintenance.dateTimeHeading" /></h2>
              <h2 style = {styles.subHeading}><FormattedMessage id="maintenance.dateTime" /></h2>
              <h3 style = {styles.textStyle}><FormattedMessage id="maintenance.message1" /> <br/> <FormattedMessage id="maintenance.message2" /></h3>
            </div>
          </Paper>
        </div>
    </div>
  
  );  
}


// WEBPACK FOOTER //
// src/layouts/LoggedIn/Maintenance.js